<app-header></app-header>
<app-menu></app-menu>

<div nxLayout='grid' class="mtop2percent">
    <form [formGroup]="workShopForm">
        <div nxRow class="disabledbutton">
            <div nxCol="12" class="nx-margin-bottom-s" colOffset="2">
                <nx-link>
                    <a>
                        <nx-icon name='user-o'></nx-icon>
                        <h3 nxHeadline="section" class="nx-margin-bottom-0">Personal Details</h3>
                    </a>
                </nx-link>
            </div>
            <div nxCol="4,4" colOffset="2">
                <nx-formfield label="Dealer Code">
                    <input nxInput formControlName="dealerCode" />
                </nx-formfield>
            </div>
            <div nxCol="4,4" *ngIf="!isDealer">
                <nx-formfield label="Workshop code">
                    <input nxInput formControlName="workshopCode" />
                </nx-formfield>
            </div>
            <div nxCol="4,4" colOffset="2" *ngIf="!isDealer">
                <nx-formfield label="Workshop Name">
                    <input nxInput formControlName="workshopName" />
                </nx-formfield>
            </div>
            <div nxCol="4,4">
                <nx-formfield label="Dealer Name" *ngIf="isDealer">
                    <input nxInput formControlName="dealerName" />
                </nx-formfield>
            </div>
            <div nxCol="4,4" colOffset="2">
                <nx-formfield label="Area Sales Manager">
                    <nx-dropdown formControlName="superUserId">
                        <nx-dropdown-item *ngFor="let item of asmUsers" [value]="item.id">{{item.name}}
                        </nx-dropdown-item>
                    </nx-dropdown>
                </nx-formfield>
            </div>
            <div nxCol="4,4">
                <nx-formfield label="Dealer Address" *ngIf="isDealer">
                    <input nxInput formControlName="dealerAddress" />
                </nx-formfield>
                <nx-formfield label="Workshop Address" *ngIf="!isDealer">
                    <input nxInput formControlName="dealerAddress" />
                </nx-formfield>
            </div>
            <div nxCol="4,4" colOffset="2">
                <nx-formfield label="Service Tax Number">
                    <input nxInput b formControlName="serviceTaxNumber" />
                </nx-formfield>
            </div>
            <div nxCol="4,4">
                <nx-formfield label="PAN Number">
                    <input nxInput formControlName="panNo" />
                </nx-formfield>
            </div>
            <div nxCol="4,4" colOffset="2">
                <nx-formfield label="Contact Person">
                    <input nxInput formControlName="contactPerson" />
                </nx-formfield>
            </div>
            <div nxCol="4,4">
                <nx-formfield label="Contact Number">
                    <input nxInput formControlName="contactNumber" />
                </nx-formfield>
            </div>
            <div nxCol="4,4" colOffset="2">
                <nx-formfield label="Primary Email">
                    <input nxInput formControlName="primaryEmailIdContactPerson" />
                </nx-formfield>
            </div>
            <div nxCol="4,4">
                <nx-formfield label="Secondary Email">
                    <input nxInput formControlName="contactPersonEmailId" />
                </nx-formfield>
            </div>
            <div nxCol="4,4" colOffset="2">
                <nx-formfield label="Region">
                    <nx-dropdown formControlName="zone">
                        <nx-dropdown-item *ngFor="let item of zoneList" [value]="item.id">{{item.zone}}
                        </nx-dropdown-item>
                    </nx-dropdown>
                </nx-formfield>
            </div>
            <div nxCol="4,4">
                <nx-formfield label="State">
                    <nx-dropdown formControlName="stateId">
                        <nx-dropdown-item *ngFor="let item of stateList" [value]="item.id">{{item.stateName}}
                        </nx-dropdown-item>
                    </nx-dropdown>
                </nx-formfield>
            </div>
            <div nxCol="4,4" colOffset="2">
                <nx-formfield label="City">
                    <nx-dropdown formControlName="cityId">
                        <nx-dropdown-item *ngFor="let item of cityList" [value]="item.id">
                            {{item.cityName}}
                        </nx-dropdown-item>
                    </nx-dropdown>
                </nx-formfield>
            </div>
            <!-- Bank details are kept hidden as per request from bussiness -->
            <div *ngIf="false">
                <div nxCol="12" class="nx-margin-bottom-s" colOffset="2">
                    <nx-link>
                        <a>
                            <nx-icon name='product-bank-monument-info'></nx-icon>
                            <h3 nxHeadline="section" class="nx-margin-bottom-0">Bank Details</h3>
                        </a>
                    </nx-link>
                </div>
                <div nxCol="4,4" colOffset="2">
                    <nx-formfield label="Bank Account Number">
                        <input nxInput formControlName="bankAccountNo" />
                    </nx-formfield>
                </div>
                <div nxCol="4,4">
                    <nx-formfield label="Bank Name">
                        <input nxInput formControlName="bankName" />
                    </nx-formfield>
                </div>
                <div nxCol="4,4" colOffset="2">
                    <nx-formfield label="IFSC Code">
                        <input nxInput formControlName="ifscCode" />
                    </nx-formfield>
                </div>
                <div nxCol="4,4">
                    <nx-formfield label="Beneficiary Name">
                        <input nxInput formControlName="beneficiaryName" />
                    </nx-formfield>
                </div>
                <div nxCol="4,4" colOffset="2">
                    <nx-formfield label="Bank Branch Address">
                        <input nxInput formControlName="bankBranchAddress" />
                    </nx-formfield>
                </div>
                <div nxCol="4" *ngIf="cancelChequePath">
                    <span style="font-size: 15px !important;font-weight: 400px !important;">Cancelled Cheque</span>
                    <br />
                    <br />
                    <div *ngIf="showPanDownlaodBtn">
                        <nx-icon name="pdf" size="m"class="red"></nx-icon>
                        <span style="vertical-align: top;" class="enabledbutton"><a href="{{cancelChequePath}}"
                                target="_blank">{{chequefilename}}</a></span>
                    </div>
                    <div *ngIf="!showPanDownlaodBtn">
                        <span style="vertical-align: top;">No attachment found</span>
                    </div>
                </div>
                <div nxCol="4" *ngIf="panCardPath" colOffset="2">
                    <span style="font-size: 15px !important;font-weight: 400px !important;">Pan Card</span>
                    <br />
                    <br />
                    <div *ngIf="showPanDownlaodBtn">
                        <nx-icon name="pdf" size="m"class="red"></nx-icon>
                        <span style="vertical-align: top;" class="enabledbutton"><a href="{{panCardPath}}"
                                target="_blank">{{panfilename}}</a></span>
                    </div>
                    <div *ngIf="!showPanDownlaodBtn">
                        <span style="vertical-align: top;">No attachment found</span>
                    </div>
                </div>
                <div nxCol="4" *ngIf="gstCardPath">
                    <span style="font-size: 15px !important;font-weight: 400px !important;">GST Certificate</span>
                    <br />
                    <br />
                    <div *ngIf="showGstDownlaodBtn">
                        <nx-icon name="pdf" size="m"class="red"></nx-icon>
                        <span style="vertical-align: top;" class="enabledbutton"><a href="{{gstCardPath}}"
                                target="_blank">{{gstfilename}}</a></span>
                    </div>
                    <div *ngIf="!showGstDownlaodBtn">
                        <span style="vertical-align: top;">No attachment found</span>
                    </div>
                </div>
            </div>
        </div>
        <div nxRow class="mtop2percent">
            <div nxCol="10" class="nx-margin-bottom-m" colOffset="2">
                <button nxButton="tertiary" type="button">
                    <a routerLink='/dashboard'>GO TO DASHBOARD <nx-icon name='chevron-right-circle-o'
                            class="nx-margin-left-s"></nx-icon></a></button>
            </div>
        </div>
    </form>
</div>

<app-footer></app-footer>